import { Box, CircularProgress, Divider } from '@mui/material';
import React from 'react';
import RemoveItem from '../../assets/images/remove-item.png';
import { styled } from 'styled-components';
import CustomButton from '../CustomButton/CustomButton';
import { truncateField } from '@src/helpers/Helpers';

const StyledText = styled.div`
	width: 274px;
	height: 44.294px;
	color: var(--default-text-color);
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	line-height: 24px;
	span {
		font-weight: 700;
	}
`;

type Props = {
	handleClose: () => void;
	handleConfirm: () => void;
	item?: { count: number; name: string };
	loading: boolean;
	content?: string;
	image?: any;
	confirmModal?: boolean;
};
const ConfirmModal: React.FC<Props> = ({
	item,
	handleClose,
	handleConfirm,
	loading,
	content,
	image = RemoveItem,
	confirmModal = false,
}) => {
	if (confirmModal) {
		return (
			<form>
				<Box
					display="flex"
					flexDirection="column"
					justifyContent="center"
					alignItems="center"
					padding="25px"
				>
					<StyledText>{content}</StyledText>
				</Box>
				<Divider style={{ width: '100%' }} />
				<Box display="flex" justifyContent="center" gap="10px" p={2}>
					<CustomButton
						title="Cancel"
						handleClick={handleClose}
						styles={{
							width: '133px',
							height: '36px',
							borderRadius: '4px',
							padding: '7px 47px 7px 47px',
							background: 'var(--btn-color-grey)',
							color: 'var(--default-text-color)',
							':hover': {
								background: 'var(--btn-hover-color) !important',
							},
						}}
					/>
					<CustomButton
						title={
							loading ? (
								<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
							) : (
								'Confirm'
							)
						}
						handleClick={handleConfirm}
						styles={{
							width: '133px',
							height: '36px',
							borderRadius: '4px',
							padding: '7px 47px 7px 47px',
							background: 'var(--color-primary)',
							color: 'var(--default-text-color)',
						}}
					/>
				</Box>
			</form>
		);
	}
	return (
		<form>
			<Box
				display="flex"
				flexDirection="column"
				justifyContent="center"
				alignItems="center"
				padding="25px"
			>
				<img src={image} alt="remove-item" width="159px" height="150px" />
				{content ? (
					<StyledText>{content}</StyledText>
				) : (
					<StyledText>
						Deleting {item?.count} items from the catalog for{' '}
						<span>{item?.name ? truncateField(item?.name, 40) : null}</span>. Are you sure?
					</StyledText>
				)}
			</Box>
			<Divider style={{ width: '100%' }} />
			<Box display="flex" justifyContent="center" gap="10px" p={2}>
				<CustomButton
					title="Cancel"
					handleClick={handleClose}
					styles={{
						width: '133px',
						height: '36px',
						borderRadius: '4px',
						padding: '7px 47px 7px 47px',
						background: 'var(--btn-color-grey)',
						color: 'var(--default-text-color)',
						':hover': {
							background: 'var(--btn-hover-color) !important',
						},
					}}
				/>
				<CustomButton
					title={
						loading ? (
							<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
						) : (
							'Confirm'
						)
					}
					handleClick={handleConfirm}
					styles={{
						width: '133px',
						height: '36px',
						borderRadius: '4px',
						padding: '7px 47px 7px 47px',
						background: 'var(--color-primary)',
						color: 'var(--default-text-color)',
					}}
				/>
			</Box>
		</form>
	);
};

export default ConfirmModal;
